ion-infinite-scroll-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 84px;
  text-align: center;
  user-select: none;
}

.infinite-loading {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  margin-bottom: 32px;
  display: none;
  width: 100%;
}

.infinite-loading-text {
  -webkit-margin-start: 32px;
  margin-inline-start: 32px;
  -webkit-margin-end: 32px;
  margin-inline-end: 32px;
  margin-top: 4px;
  margin-bottom: 0;
}

.infinite-scroll-loading ion-infinite-scroll-content > .infinite-loading {
  display: block;
}

.infinite-scroll-content-md .infinite-loading-text {
  color: var(--ion-color-step-600, #666666);
}

.infinite-scroll-content-md .infinite-loading-spinner .spinner-lines-md line,
.infinite-scroll-content-md .infinite-loading-spinner .spinner-lines-small-md line,
.infinite-scroll-content-md .infinite-loading-spinner .spinner-crescent circle {
  stroke: var(--ion-color-step-600, #666666);
}

.infinite-scroll-content-md .infinite-loading-spinner .spinner-bubbles circle,
.infinite-scroll-content-md .infinite-loading-spinner .spinner-circles circle,
.infinite-scroll-content-md .infinite-loading-spinner .spinner-dots circle {
  fill: var(--ion-color-step-600, #666666);
}